import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CedingSchemeModel } from '../../Models/Models/Transfer/CedingSchemeModel';
import { SubAccountType } from '../../Constants/Enums/Domain/SubAccountType';

declare var IS_RUNNING_IN_APP_POOL;

export class CedingSchemeClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(type: SubAccountType, partialName: string): Promise<Array<CedingSchemeModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transfer/CedingScheme/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { type: type, partialName: partialName }

    return AjaxWrapper.get<Array<CedingSchemeModel>, any>(url, data);
  }
}

